import { useTranslation } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/es';
import 'moment/locale/pt-br';
import {
  SchedulingConfirmInformationInterface,
  SchedulingConfirmItems,
} from '../SchedulingInterface';
import {
  LocalHospitalOutlined,
  MedicalServicesOutlined,
  MonetizationOnOutlined,
  EventOutlined,
} from '@mui/icons-material';

import { styles } from './styles';
import { Avatar } from '@mui/material';
import { getInitials } from '@/utils/getInitials';
import { dateFormatter } from '@/utils/dateFormatter';
import { useMemo } from 'react';

interface ScheduleItemsInterface {
  internalObject: SchedulingConfirmInformationInterface;
}

export const ScheduleItems = ({
  internalObject,
}: ScheduleItemsInterface): Array<SchedulingConfirmItems> => {
  const { t } = useTranslation(['schedule', 'appointmentDetails']);
  const { confirmBannerSchedule } = dateFormatter();

  // const dataConverted = useMemo(() => {
  //   const dateStr = moment(internalObject.date).format('YYYY-MM-DD');
  //   const timeMatch = internalObject.time.match(/[0-9]{1,2}:[0-9]{2} ?([AaPp][Mm])?/);
  //   const timeStr = timeMatch ? timeMatch[0].toUpperCase() : '';

  //   const combined = `${dateStr} ${timeStr}`;

  //   // Tenta interpretar AM/PM ou 24h
  //   const originalMoment = moment(combined, ['YYYY-MM-DD hh:mm A', 'YYYY-MM-DD HH:mm'], true);

  //   if (!originalMoment.isValid()) {
  //     console.error('Data/Hora inválida:', combined);
  //     return {
  //       asDate: new Date(),
  //       timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  //       time: 'Inválido',
  //       display: 'Data/Hora inválida',
  //     };
  //   }

  //   return {
  //     asDate: originalMoment.toDate(), // pega como horário local
  //     timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  //     time: originalMoment.format('hh:mm A'),
  //     display: originalMoment.format('YYYY-MM-DD hh:mm A'),
  //   };
  // }, [internalObject.date, internalObject.time]);

  const dataConverted = useMemo(() => {
    console.log('INTERNAL::ITEMS::', internalObject);

    const dateStr = moment(internalObject.date).format('YYYY-MM-DD');

    const timeMatch = internalObject.time.match(
      /[0-9]{1,2}:[0-9]{2} ?([AaPp][Mm])?/
    );
    const timeStr = timeMatch ? timeMatch[0].toUpperCase() : '';

    const combined = `${dateStr} ${timeStr}`;
    const clinicGMT = -4;

    // Converte para UTC assumindo que o horário recebido é GMT-5
    const originalMoment = moment.utc(
      combined,
      ['YYYY-MM-DD hh:mm A', 'YYYY-MM-DD HH:mm'],
      true
    );

    if (!originalMoment.isValid()) {
      console.error('Data/Hora inválida:', combined);
      return {
        asDate: new Date(),
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        time: 'Inválido',
        display: 'Data/Hora inválida',
      };
    }

    // Ajusta o horário GMT-5 para UTC
    const utcMoment = originalMoment.add(clinicGMT * -1, 'hours');

    // Converte para horário local do usuário
    const localMoment = utcMoment.local();

    return {
      asDate: localMoment.toDate(),
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      time: localMoment.format('hh:mm A'),
      display: localMoment.format('YYYY-MM-DD hh:mm A'),
    };
  }, [internalObject.date, internalObject.time]);

  return [
    {
      title: t('screen_choose_confirm_schedule_patient'),
      text: internalObject.patientName,
      iconLeft: (
        <Avatar
          alt={internalObject.patientName}
          src={internalObject.patientPhoto}
          sx={styles.photo}
        >
          {getInitials(internalObject.patientName)}
        </Avatar>
      ),
    },
    {
      title: t('screen_choose_confirm_schedule_schedule_type'),
      text: `${
        internalObject.scheduleType === 'Online' || internalObject.scheduleType === '2'
          ? t('appointmentDetails:online_consultation')
          : `${t('in_person')} | ${internalObject.address}`
      }`,

      iconLeft: <LocalHospitalOutlined sx={styles.iconLeft} />,
    },
    {
      title: t('screen_choose_confirm_schedule_doctor'),
      text: t(internalObject.doctorName),
      iconLeft: <MedicalServicesOutlined sx={styles.iconLeft} />,
    },
    {
      title: t('screen_choose_confirm_schedule_date_time'),
      text: confirmBannerSchedule(internalObject.date),

      subText: `${dataConverted.time} (${dataConverted.timeZone})`,

      iconLeft: <EventOutlined sx={styles.iconLeft} />,
    },
    {
      title: t('screen_choose_confirm_schedule_payment_type'),
      text: t(internalObject.paymentType),
      subText: (() => {
        if (internalObject.creditCardDTO && internalObject.creditCard) {
          return `${internalObject.creditCardDTO.banner} **** ${internalObject.creditCardDTO.lastDigits}`;
        }

        if (internalObject.creditCard) {
          return internalObject.creditCard;
        }

        if (internalObject.banner && internalObject.cardLast4Digits) {
          return `${internalObject.banner} **** ${internalObject.cardLast4Digits}`;
        }

        return '';
      })(),

      iconLeft: <MonetizationOnOutlined sx={styles.iconLeft} />,
    },
  ];
};
